import afterpayUtils from 'utils/Afterpay';
import basketUtils from 'utils/Basket';
import decorators from 'utils/decorators';
import OrderActions from 'actions/OrderActions';
import Actions from 'Actions';
import { INTERSTICE_DELAY_MS } from 'constants/Checkout';
import {
    SHOW_ERROR,
    RESET_ERROR,
    TOGGLE_SELECTED,
    SET_READY,
    SET_WIDGET_DATA,
    SET_WIDGET_LOADING,
    SET_WIDGET_ERROR
} from 'constants/actionTypes/afterpay';

function toggleSelect(isSelected) {
    return {
        type: TOGGLE_SELECTED,
        isSelected
    };
}

function showError(errorMessage, fireAnalytics = false) {
    return {
        type: SHOW_ERROR,
        error: {
            errorMessage,
            fireAnalytics
        }
    };
}

function resetError() {
    return {
        type: RESET_ERROR
    };
}

function setReady(readyStatus) {
    return {
        type: SET_READY,
        isReady: readyStatus
    };
}

const loadWidget = (id, ammount, errorMessage) => dispatch => {
    decorators
        .withInterstice(afterpayUtils.initPaymentGroup, INTERSTICE_DELAY_MS)()
        .then(order => {
            dispatch(OrderActions.updateOrder(order));
            dispatch(setReady(false));
            afterpayUtils
                .initCheckoutWidget(id, basketUtils.removeCurrency(ammount), () => dispatch(showError(errorMessage, true)))
                .then(() => {
                    dispatch(setReady(true));
                })
                .catch(error => {
                    // eslint-disable-next-line no-console
                    console.error(error);
                    dispatch(showError(errorMessage, true));
                });
        })
        .catch(error => {
            dispatch(Actions.showInterstice(false));
            //eslint-disable-next-line no-console
            console.error(error);
            dispatch(showError(errorMessage, true));
        });
};

const setPaymentMethod = errorMessage => dispatch => {
    decorators
        .withInterstice(afterpayUtils.initPaymentGroup, INTERSTICE_DELAY_MS)()
        .then(order => {
            dispatch(OrderActions.updateOrder(order));
            dispatch(setReady(true));
        })
        .catch(error => {
            dispatch(Actions.showInterstice(false));
            Sephora.logger.error('Afterpay setPaymentMethod error:', error);
            dispatch(showError(errorMessage, true));
        });
};

const updateWidget = ammount => {
    afterpayUtils.updateCheckoutWidget(basketUtils.removeCurrency(ammount));
};

const placeOrder =
    ({ errorMessage }) =>
        dispatch => {
            if (Sephora.isDesktop()) {
                dispatch(Actions.showInterstice(true));
            }

            return afterpayUtils
                .showPopup()
                .then(data => {
                    if (data.status === 'SUCCESS') {
                        return data;
                    } else {
                        dispatch(Actions.showInterstice(false));

                        return null;
                    }
                })
                .catch(error => {
                // eslint-disable-next-line no-console
                    console.error(error);
                    dispatch(Actions.showInterstice(false));
                    dispatch(showError(errorMessage, true));

                    return null;
                });
        };

/**
 * Loads the Afterpay SDK widget that displays the payment schedule breakdown.
 * This is called when the user expands the Afterpay view (clicks Afterpay pill button).
 *
 * @param {string} elementId - DOM element ID where Afterpay SDK will render widget (e.g., 'afterpay-widget-expanded-view')
 * @param {number} amount - Order total amount (will be converted to installments by Afterpay)
 * @returns {Function} Redux thunk that returns a promise
 * @async
 * @throws {Error} Widget initialization error (handled gracefully, dispatches SET_WIDGET_ERROR)
 */
const loadExpandedViewWidget = (elementId, amount) => async dispatch => {
    dispatch({
        type: SET_WIDGET_LOADING,
        isLoading: true
    });

    try {
        // Load Afterpay SDK widget
        // Error callback handles widget-level errors (onError event from SDK)
        await afterpayUtils.initCheckoutWidget(elementId, basketUtils.removeCurrency(amount), error => {
            dispatch({
                type: SET_WIDGET_ERROR,
                error: error
            });
        });

        // Success: Widget loaded and ready
        dispatch({
            type: SET_WIDGET_DATA,
            widgetData: {
                elementId: elementId, // Used by component to render container
                isReady: true // Indicates widget is interactive
            }
        });
        dispatch({
            type: SET_WIDGET_LOADING,
            isLoading: false
        });
    } catch (error) {
        Sephora.logger.error('Afterpay widget load error:', error);
        dispatch({
            type: SET_WIDGET_ERROR,
            error: error
        });
        dispatch({
            type: SET_WIDGET_LOADING,
            isLoading: false
        });
    }
};

export default {
    toggleSelect,
    showError,
    resetError,
    setReady,
    loadWidget,
    updateWidget,
    placeOrder,
    loadExpandedViewWidget,
    setPaymentMethod
};
